import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'irembogov-delete-confirmation-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Confirm Deletion</h4>

      <span class="cursor-pointer" (click)="modal.dismiss('Cross click')">
        <i class="fa fa-close" ngbTooltip="Close Modal"></i>
      </span>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete this transition?</p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss('cancel')">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-danger"
        (click)="modal.close('confirm')">
        Delete
      </button>
    </div>
  `,
})
export class DeleteConfirmationModalComponent {
  constructor(public modal: NgbActiveModal) {}
}
